const DASHBOARD_BARS = [52, 74, 46, 92, 68, 58];
const AUTOMATION_RAILS = [78, 54, 68];
const MOBILE_STACK = [0, 1, 2];

export default function CaseStudyPreview({ variant = 'dashboard', label = 'Interface preview' }) {
  if (variant === 'mobile') {
    return (
      <div className="case-preview case-preview--mobile" aria-label={label}>
        <div className="case-preview__caption">{label}</div>
        <div className="case-preview__mobile-stage">
          {MOBILE_STACK.map((item) => (
            <div key={item} className={`case-preview__phone case-preview__phone--${item}`}>
              <div className="case-preview__phone-notch" />
              <div className="case-preview__phone-surface">
                <div className="case-preview__phone-chart" />
                <div className="case-preview__phone-card" />
                <div className="case-preview__phone-lines">
                  <span />
                  <span />
                  <span />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'automation') {
    return (
      <div className="case-preview case-preview--automation" aria-label={label}>
        <div className="case-preview__caption">{label}</div>
        <div className="case-preview__automation-grid">
          <div className="case-preview__workflow">
            <div className="case-preview__workflow-node is-primary" />
            <div className="case-preview__workflow-node" />
            <div className="case-preview__workflow-node" />
            <div className="case-preview__workflow-line is-top" />
            <div className="case-preview__workflow-line is-mid" />
          </div>
          <div className="case-preview__automation-panel">
            {AUTOMATION_RAILS.map((width) => (
              <span key={width} style={{ width: `${width}%` }} />
            ))}
            <div className="case-preview__automation-callout" />
          </div>
          <div className="case-preview__automation-terminal">
            <span />
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="case-preview case-preview--dashboard" aria-label={label}>
      <div className="case-preview__caption">{label}</div>
      <div className="case-preview__window">
        <div className="case-preview__window-top">
          <span />
          <span />
          <span />
        </div>
        <div className="case-preview__dashboard-layout">
          <aside className="case-preview__sidebar">
            <span />
            <span />
            <span />
            <span />
          </aside>
          <div className="case-preview__dashboard-main">
            <div className="case-preview__metric-row">
              <div className="case-preview__metric-card is-large" />
              <div className="case-preview__metric-card" />
              <div className="case-preview__metric-card" />
            </div>
            <div className="case-preview__chart-card">
              <div className="case-preview__bars">
                {DASHBOARD_BARS.map((height, index) => (
                  <span key={`${height}-${index}`} style={{ height: `${height}%` }} />
                ))}
              </div>
            </div>
            <div className="case-preview__table-card">
              <span />
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
